import { CentraJS } from "@frend-digital/centra-js-client";
import type { BaseSelectionResponse } from "@frend-digital/centra-types/selection";

export type ChangePasswordVariables = {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export interface ChangePasswordOptions<FormattedSelection> {
  variables: ChangePasswordVariables;
  customerToken: string;
  api: string;
  formatter: (arg0: BaseSelectionResponse) => FormattedSelection;
}

const changePassword = async <FormattedSelection>({
  variables,
  customerToken,
  api,
  formatter,
}: ChangePasswordOptions<FormattedSelection>) => {
  const { oldPassword, newPassword, confirmPassword } = variables;

  if (newPassword !== confirmPassword) throw Error("Passwords do not match");

  CentraJS.suspend();

  const res = await fetch(
    `${api}/password`,

    {
      headers: { "API-token": customerToken || "" },
      method: "PUT",
      body: JSON.stringify({
        password: oldPassword,
        newPassword,
      }),
    }
  );

  CentraJS.resume();

  if (!res.ok) throw Error("Error changing password");
  const response = await res.json();
  return formatter(response);
};

export default changePassword;
